import React from 'react';
import { Route } from "react-router-dom";
import { get } from 'lodash';
import PageLayoutWrapper from "../common/components/PageLayoutWrapper";
import ContentContext from '../utils/ContentContext';
import FooterContainer from "../common/components/footer";
import FooterAEMContainer from "../common/components/footerAEM";
import HeaderAEMContainer from "../common/components/headerAEM/Header";


const ProtectedRoute = ({
  component: Component, routeConfig,
  location, authenticating, authStatus, history, ...rest
}) => {
  const contextType = ContentContext;
  const { MULTI_TAB_SESSION } = window.weeksWebCloudConfig;
  const context = get(contextType, '_currentValue');
  return (<Route  {...rest} render={(props) => {
    return (<>
      {context && <HeaderAEMContainer />}
      {MULTI_TAB_SESSION ?
        <div className="main-body" id={routeConfig?.pageName} role="main">
          <Component routeConfig={routeConfig} {...props} />
        </div>
        :
        <PageLayoutWrapper>
          <Component routeConfig={routeConfig} {...props} />
        </PageLayoutWrapper>
      }
      {context ? <FooterAEMContainer location={location} type={routeConfig.pageName} /> : <FooterContainer location={location} type={routeConfig.pageName} />}
    </>)
  }} />

  )
}
export default ProtectedRoute;

